<h1 class="mb-4"><mdb-icon fas icon="cog"></mdb-icon> Usuarios</h1>
<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Configuración Usuarios</span>
      <span> /</span>
      <span>Usuarios</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6">
        <div></div>
        <button type="button" mdbBtn color="info" (click)="showNew(); showModalAgregar()" size="sm" mdbWavesEffect>
          Agregar
        </button>
      </div>
      <div class="row filtros-body align-items-center">
        <div class="col" style="max-width: 250px">
          <!-- Material inline 1 -->
          <div class="form-check form-check-inline">
            <input type="radio" class="form-check-input" id="materialInline1" formControlName="tipoVista"
              [(ngModel)]="options" [value]="RB_TIPO_VISTA_RUT" mdbInput />
            <label class="form-check-label" for="materialInline1">RUT</label>
          </div>

          <!-- Material inline 2 -->
          <div class="form-check form-check-inline">
            <input type="radio" class="form-check-input" id="materialInline2" [(ngModel)]="options"
              formControlName="tipoVista" [value]="RB_TIPO_VISTA_NOMBRE" mdbInput />
            <label class="form-check-label" for="materialInline2">Nombre</label>
          </div>
        </div>

        <div class="col" style="max-width: 150px">
          <div *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RUT" class="md-form mb-0">
            <input value="" type="text" id="rut_usuario" [(ngModel)]="rut" formControlName="rut_user"
              class="form-control" placeholder="RUT" required #rut_usuario />
            <label for="rut_usuario">RUT</label>
          </div>
          <div *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_NOMBRE" class="md-form mb-0">
            <input value="" type="text" id="nombre_completo" [(ngModel)]="nombre" formControlName="nombre_usuario"
              class="form-control" placeholder="Nombre" required #nombre_completo />
            <label for="nombre_completo">Nombre</label>
          </div>
        </div>
        <div class="col" style="max-width: 200px">
          <div class="md-form mb-0">
            <mdb-select [options]="optionsRol" [multiple]="true" [(ngModel)]="roles_codigo" [filterEnabled]="true"
              [highlightFirst]="false" formControlName="roles_codigo" placeholder="Rol"></mdb-select>
            <label>Roles</label>
          </div>
        </div>
        <div class="col" style="max-width: 200px">
          <div class="md-form mb-0">
            <mdb-select [options]="optionsSucursal" [multiple]="true" [(ngModel)]="sucursal_codigo"
              formControlName="sucursal_codigo" [filterEnabled]="true" [highlightFirst]="false" placeholder="Sucursal">
            </mdb-select>
            <label>Sucursales</label>
          </div>
        </div>
        <div class="col" style="max-width: 150px">

          <mdb-checkbox formControlName="activo"><span>Activo</span>
          </mdb-checkbox>

        </div>
      </div>
    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div></div>
      <div class="card-footer text-muted filtros-footer justify-content-end" style="border-top: 1px solid #dee2e6">
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="limpiarFiltro()">
          <mdb-icon fas icon="broom"></mdb-icon>
          Limpiar
        </button>
        <button mdbBtn type="button" color="secondary" (click)="obtenerSegunFiltroUsuarioxEmpresa()" size="sm"
          mdbWavesEffect>
          <mdb-icon fas icon="search"></mdb-icon> Buscar
        </button>
      </div>

    </div>
  </div>
</form>


<!-- Listado -->
<div class="card mb-2 wow">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">RUT</th>
            <th scope="col">Usuario</th>
            <th scope="col">Nombre</th>
            <th scope="col">Rol</th>
            <th scope="col">Email</th>
            <th scope="col">Fecha de creación</th>
            <th scope="col">Estado</th>
            <th scope="col"></th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="!usuarioList || usuarioList.length === 0">
            <td colspan="7" style="text-align: center">
              No se encontro informacion
            </td>
          </tr>
          <tr *ngFor="let usu of usuarioList">
            <td>{{ usu.rutFormato | rut }}</td>
            <td>{{ usu.login }}</td>
            <td>{{ usu.nombre_completo }}</td>
            <td>{{ usu.rol_nombre }}</td>
            <td>{{ usu.mail }}</td>
            <td>{{ usu.fecha_creacion | date: "dd/MM/yyyy" }}</td>
            <td>
              <div *ngIf="usu.activo">
                <mdb-badge pill="true" success="true">Activo</mdb-badge>
              </div>
              <div *ngIf="!usu.activo">
                <mdb-badge pill="true" warning="true">Inactivo</mdb-badge>
              </div>
            </td>
            <td>
              <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                (click)="showForEdit(usu); showModalModificar()" mdbTooltip="Editar" placement="right">
                <mdb-icon fas icon="pen"></mdb-icon>
              </button>
              <button *ngIf="usu.activo" mdbBtn type="button" size="sm" color="primary" mdbWavesEffect
                class="btn-actions-sm" (click)="permitirCambioEstado(usu)" mdbTooltip="Desactivar" placement="right">
                <mdb-icon fas icon="ban"></mdb-icon>
              </button>
              <button *ngIf="!usu.activo" mdbBtn type="button" size="sm" color="success" mdbWavesEffect
                class="btn-actions-sm" (click)="permitirCambioEstado(usu)" mdbTooltip="Activar" placement="right">
                <mdb-icon fas icon="check"></mdb-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- MODAL Agregar usuario -->
<div style="overflow-y: auto" mdbModal #agregarUsuario="mdb-modal" class="modal fade" id="basicExample" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <form [formGroup]="formulario" (ngSubmit)="
          ValidaQueExisteDatosUsuario(usuarioSucursalList);
          agregarUsuario.hide()
        ">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">Agregar</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="agregarUsuario.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col">
              <h5 class="modal-title w-100 text-left" id="myModalLabel">
                Datos de usuario
              </h5>
            </div>
            <div class="col">
              <div class="switch">
                <label>Inactivo<input formControlName="activo" type="checkbox" checked /><span
                    class="lever"></span>Activo</label>
              </div>
            </div>
          </div>
          <div class="row">
            <!-- Left -->
            <div class="col">
              <div class="md-form">
                <input formControlName="rut_usuario" value="" type="text" id="arut" class="form-control"
                  placeholder="9.999.999-9" required #rut_usuario maxLength="13" (blur)="mascaraRut($event)" />
                <label for="rut">RUT</label>
                <div *ngIf="
                    formulario.get('rut_usuario').invalid &&
                    (formulario.get('rut_usuario').dirty ||
                      formulario.get('rut_usuario').touched)
                  ">
                  <mdb-error *ngIf="
                      formulario.get('rut_usuario').hasError('ValidaFormatoRut')
                    ">Por favor ingrese un RUT Valido</mdb-error>
                  <mdb-error *ngIf="formulario.get('rut_usuario').hasError('required')"></mdb-error>
                  <mdb-error *ngIf="formulario.get('rut_usuario').hasError('maxlength')"></mdb-error>
                  <mdb-error *ngIf="formulario.get('rut_usuario').hasError('minlength')"></mdb-error>
                </div>
              </div>
              <div class="md-form">
                <input formControlName="login" value="" type="text" id="ausuario" class="form-control"
                  placeholder="Usuario" required #usuario maxLength="20" />
                <label for="usuario">Usuario</label>
                <div *ngIf="
                    formulario.get('login').invalid &&
                    (formulario.get('login').dirty ||
                      formulario.get('login').touched)
                  ">
                  <mdb-error *ngIf="formulario.get('login').hasError('required')">El Usuario es requerido.</mdb-error>
                  <mdb-error *ngIf="formulario.get('login').hasError('maxlength')">El Usuario no puede superar los 20
                    caracteres.</mdb-error>
                  <mdb-error *ngIf="formulario.get('login').hasError('minlength')">El Usuario debe tener como mínimo 5
                    caracteres.</mdb-error>
                </div>
              </div>
              <div class="md-form">
                <input formControlName="nombre_completo" value="" type="text" id="anombreApellido" class="form-control"
                  placeholder="Nombre y Apellido" required #nombreApellido maxLength="100" />
                <label for="nombreApellido">Nombre y Apellido</label>
                <div *ngIf="
                    formulario.get('nombre_completo').invalid &&
                    (formulario.get('nombre_completo').dirty ||
                      formulario.get('nombre_completo').touched)
                  ">
                  <mdb-error *ngIf="
                      formulario.get('nombre_completo').hasError('required')
                    ">El Nombre es requerido.</mdb-error>
                  <mdb-error *ngIf="
                      formulario.get('nombre_completo').hasError('maxlength')
                    ">El Nombre no puede superar los 100 caracteres.</mdb-error>
                  <mdb-error *ngIf="
                      formulario.get('nombre_completo').hasError('minlength')
                    ">El Nombre debe tener como mínimo 5 caracteres.</mdb-error>
                </div>
              </div>
              <div class="md-form">
                <input formControlName="mail" value="" type="email" id="aemail" class="form-control" placeholder="Email"
                  required #email />
                <label for="email">Email</label>
                <div *ngIf="
                    formulario.get('mail').invalid &&
                    (formulario.get('mail').dirty ||
                      formulario.get('mail').touched)
                  ">
                  <mdb-error *ngIf="formulario.get('mail').hasError('required')">El Correo es requerido.</mdb-error>
                  <mdb-error *ngIf="formulario.get('mail').hasError('email')">El Correo no es valido.</mdb-error>
                </div>
              </div>
            </div>

            <!-- Right -->
            <div class="col">
              <div class="md-form  input-group">
                <input formControlName="password" value="" [type]="fieldTextType ? 'text' : 'password'" id="apass"
                  class="form-control" placeholder="Contraseña" required #pass maxLength="15" />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa" [ngClass]="{
                      'fa-eye-slash': !fieldTextType,
                      'fa-eye': fieldTextType
                    }" (click)="toggleFieldTextType()"></i>
                  </span>
                </div>
                <label for="pass">Contraseña</label>
                <div *ngIf="
                    formulario.get('password').invalid &&
                    (formulario.get('password').dirty ||
                      formulario.get('password').touched)
                  ">
                  <mdb-error *ngIf="formulario.get('password').hasError('required')">La Contraseña es requerido.
                  </mdb-error>
                  <mdb-error *ngIf="formulario.get('password').hasError('maxlength')">La Contraseña no puede superar los
                    15
                    caracteres.</mdb-error>
                  <mdb-error *ngIf="formulario.get('password').hasError('minlength')">La Contraseña tener como mínimo 5
                    caracteres.</mdb-error>
                </div>
              </div>

              <div class="md-form input-group">
                <input value="" formControlName="confirmarpass" [type]="ConfirmPassHidden ? 'text' : 'password'"
                  id="aconfirmarPass" class="form-control" placeholder="Confirmar contraseña" required #confirmarPass
                  maxLength="15" />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa" [ngClass]="{
                      'fa-eye-slash': !ConfirmPassHidden,
                      'fa-eye': ConfirmPassHidden
                    }" (click)="ShowAndHiddenConfirmPass()"></i>
                  </span>
                </div>
                <label for="confirmarPass">Confirmar contraseña</label>
                <div *ngIf="
                    formulario.get('confirmarpass').invalid &&
                    (formulario.get('confirmarpass').dirty ||
                      formulario.get('confirmarpass').touched)
                  ">
                  <mdb-error *ngIf="formulario.get('confirmarpass').hasError('required')">La Confirmacion de Contraseña
                    es requerido.</mdb-error>
                  <mdb-error *ngIf="
                      formulario.get('confirmarpass').hasError('maxlength')
                    ">La Confirmacion de Contraseña no puede superar los 15
                    caracteres.</mdb-error>
                  <mdb-error *ngIf="
                      formulario.get('confirmarpass').hasError('minlength')
                    ">La Confirmacion de Contraseña debe tener como mínimo 5
                    caracteres.</mdb-error>
                  <mdb-error *ngIf="formulario.get('confirmarpass').hasError('mismatch')">La Contraseña no coincide.
                  </mdb-error>
                </div>
              </div>
              <div class="md-form">
                <mdb-select formControlName="rol" label="Rol" [options]="optionsRol" placeholder="Roles"></mdb-select>
                <div *ngIf="
                    formulario.get('rol').invalid &&
                    (formulario.get('rol').dirty ||
                      formulario.get('rol').touched)
                  ">
                  <mdb-error *ngIf="formulario.get('rol').hasError('required')">Por favor seleccione un Rol</mdb-error>
                </div>
              </div>
              <div class="md-form">
                <input formControlName="max_sesiones" value="" type="text" id="max_sesiones" class="form-control"
                  placeholder="1" required #max_sesiones />
                <label for="max_sesiones">Máximo de sesiones concurridas</label>
                <div *ngIf="
                    formulario.get('max_sesiones').invalid &&
                    (formulario.get('max_sesiones').dirty ||
                      formulario.get('max_sesiones').touched)
                  ">
                  <mdb-error *ngIf="formulario.get('max_sesiones').hasError('min')">Como minimo debe tener 1 sesión</mdb-error>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="md-form">
                <mdb-select formControlName="sucursal" label="Sucursales" [options]="optionsSucursal"
                  placeholder="Sucursales"></mdb-select>
              </div>
            </div>
            <div class="col" style="max-width: 200px">
              <button type="button" mdbBtn color="info" [disabled]="
                  formulario.get('rut_usuario').hasError('ValidaFormatoRut')
                " (click)="agregarSucursal()" size="sm" mdbWavesEffect>
                Agregar
              </button>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-striped table-hover table-sm align-middle">
              <thead class="grey lighten-2">
                <tr>
                  <th scope="col">Codigo</th>
                  <th scope="col">Sucursal</th>
                  <th scope="col">Fecha de asignación</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="
                    !usuarioSucursalList || usuarioSucursalList.length === 0
                  ">
                  <td colspan="7" style="text-align: center">
                    Debe agregar una Sucursal
                  </td>
                </tr>
                <tr *ngFor="let suc of usuarioSucursalList; let i = index">
                  <td>{{ suc.sucursal_codigo }}</td>
                  <td>{{ suc.nombre }}</td>
                  <td>{{ suc.fecha_asignacion | date: "dd/MM/yyyy" }}</td>
                  <td>
                    <button mdbBtn type="button" size="sm" color="primary" mdbWavesEffect class="btn-actions-sm"
                      (click)="eliminarSucursal(i)">
                      <mdb-icon fas icon="trash"></mdb-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="agregarUsuario.hide()"
            mdbWavesEffect>
            Cerrar
          </button>
          <button type="submit" class="btn btn-secondary waves-light" mdbWavesEffect [disabled]="
              formulario.invalid ||
              !usuarioSucursalList ||
              usuarioSucursalList.length === 0
            ">
            Guardar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- MODAL Editar usuario -->
<div style="overflow-y: auto" mdbModal #editarUsuario="mdb-modal" class="modal fade" id="basicExample" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <form [formGroup]="formulario" (ngSubmit)="actualizar(usuarioSucursalList); editarUsuario.hide()">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">Editar</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="editarUsuario.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col">
              <h5 class="modal-title w-100 text-left" id="myModalLabel">
                Datos de usuario
              </h5>
            </div>
            <div class="col">
              <div class="switch">
                <label>Inactivo<input formControlName="activo" type="checkbox" checked /><span
                    class="lever"></span>Activo</label>
              </div>
            </div>
          </div>
          <div class="row">
            <!-- Left -->
            <div class="col">
              <div class="md-form">
                <input formControlName="rut_usuario" value="" type="text" id="erut" class="form-control"
                  placeholder="9.999.999-9" required #rut_usuario maxLength="10" />
                <label for="rut">RUT</label>
              </div>
              <div class="md-form">
                <input formControlName="login" value="" type="text" id="eusuario" class="form-control"
                  placeholder="Usuario" required #usuario />
                <label for="usuario">Usuario</label>
              </div>
              <div class="md-form">
                <input formControlName="nombre_completo" value="" type="text" id="enombreApellido" class="form-control"
                  placeholder="Nombre y Apellido" required #nombreApellido maxlength="100" />
                <label for="nombreApellido">Nombre y Apellido</label>
                <div *ngIf="
                    formulario.get('nombre_completo').invalid &&
                    (formulario.get('nombre_completo').dirty ||
                      formulario.get('nombre_completo').touched)
                  ">
                  <mdb-error *ngIf="
                      formulario.get('nombre_completo').hasError('required')
                    ">El Nombre es requerido.</mdb-error>
                  <mdb-error *ngIf="
                      formulario.get('nombre_completo').hasError('maxlength')
                    ">El Nombre no puede superar los 100 caracteres.</mdb-error>
                  <mdb-error *ngIf="
                      formulario.get('nombre_completo').hasError('minlength')
                    ">El Nombre debe tener como mínimo 5 caracteres.</mdb-error>
                </div>
              </div>
              <div class="md-form">
                <input formControlName="mail" value="" type="email" id="eemail" class="form-control" placeholder="Email"
                  required #email />
                <label for="email">Email</label>
                <div *ngIf="
                    formulario.get('mail').invalid &&
                    (formulario.get('mail').dirty ||
                      formulario.get('mail').touched)
                  ">
                  <mdb-error *ngIf="formulario.get('mail').hasError('required')">El Correo es requerido.</mdb-error>
                  <mdb-error *ngIf="formulario.get('mail').hasError('email')">El Correo no es valido.</mdb-error>
                </div>
              </div>
            </div>

            <!-- Right -->
            <div class="col">
              <div class="md-form">
                <input formControlName="password" value="" type="password" id="epass" class="form-control"
                  placeholder="Contraseña" required #pass maxlength="15" />
                <label for="pass">Contraseña</label>
                <div *ngIf="
                    formulario.get('password').invalid &&
                    (formulario.get('password').dirty ||
                      formulario.get('password').touched)
                  ">
                  <mdb-error *ngIf="formulario.get('password').hasError('required')">La Contraseña es
                    requerido.</mdb-error>
                  <mdb-error *ngIf="formulario.get('password').hasError('maxlength')">La Contraseña no puede superar los
                    15
                    caracteres.</mdb-error>
                  <mdb-error *ngIf="formulario.get('password').hasError('minlength')">La Contraseña tener como mínimo 5
                    caracteres.</mdb-error>
                </div>
              </div>
              <div class="md-form">
                <input formControlName="confirmarpass" value="" type="password" id="econfirmarPass" class="form-control"
                  placeholder="Confirmar contraseña" required #confirmarPass maxlength="15" />
                <label for="confirmarPass">Confirmar contraseña</label>
                <div *ngIf="
                    formulario.get('confirmarpass').invalid &&
                    (formulario.get('confirmarpass').dirty ||
                      formulario.get('confirmarpass').touched)
                  ">
                  <mdb-error *ngIf="formulario.get('confirmarpass').hasError('required')">La Confirmacion de Contraseña
                    es requerido.</mdb-error>
                  <mdb-error *ngIf="
                      formulario.get('confirmarpass').hasError('maxlength')
                    ">La Confirmacion de Contraseña no puede superar los 15
                    caracteres.</mdb-error>
                  <mdb-error *ngIf="
                      formulario.get('confirmarpass').hasError('minlength')
                    ">La Confirmacion de Contraseña debe tener como mínimo 5
                    caracteres.</mdb-error>
                  <mdb-error *ngIf="formulario.get('confirmarpass').hasError('mismatch')">La Contraseña no
                    coincide.</mdb-error>
                </div>
              </div>
              <div class="md-form">
                <mdb-select formControlName="rol" label="Rol" [options]="optionsRol" selected placeholder="Rol">
                </mdb-select>
                <div *ngIf="
                    formulario.get('rol').invalid &&
                    (formulario.get('rol').dirty ||
                      formulario.get('rol').touched)
                  ">
                  <mdb-error *ngIf="formulario.get('rol').hasError('required')">La Contraseña es requerido.</mdb-error>
                </div>
              </div>
              <div class="md-form">
                <input formControlName="max_sesiones" value="" type="text" id="max_sesiones" class="form-control"
                  placeholder="1" required #max_sesiones />
                <label for="max_sesiones">Máximo de sesiones concurridas</label>
                <div *ngIf="
                    formulario.get('max_sesiones').invalid &&
                    (formulario.get('max_sesiones').dirty ||
                      formulario.get('max_sesiones').touched)
                  ">
                  <mdb-error *ngIf="formulario.get('max_sesiones').hasError('min')">Como minimo debe tener 1 sesión</mdb-error>
                  <mdb-error *ngIf="formulario.get('max_sesiones').hasError('max')">Como maximo debe tener 100 sesiones</mdb-error>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="md-form">
                <mdb-select formControlName="sucursal" label="Sucursales" [options]="optionsSucursal"
                  placeholder="Sucursales"></mdb-select>
              </div>
            </div>
            <div class="col" style="max-width: 200px">
              <button type="button" mdbBtn color="info" mdbWavesEffect (click)="agregarSucursal()">
                Agregar
              </button>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-striped table-hover table-sm align-middle">
              <thead class="grey lighten-2">
                <tr>
                  <th scope="col">Codigo</th>
                  <th scope="col">Sucursal</th>
                  <th scope="col">Fecha de asignación</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="
                    !usuarioSucursalList || usuarioSucursalList.length === 0
                  ">
                  <td colspan="7" style="text-align: center">
                    Debe agregar una Sucursal
                  </td>
                </tr>
                <tr *ngFor="let suc of usuarioSucursalList; let i = index">
                  <td>{{ suc.sucursal_codigo }}</td>
                  <td>{{ suc.nombre }}</td>
                  <td>{{ suc.fecha_asignacion | date: "dd/MM/yyyy" }}</td>
                  <td>
                    <button mdbBtn type="button" size="sm" color="primary" mdbWavesEffect class="btn-actions-sm"
                      (click)="eliminarSucursal(i)">
                      <mdb-icon fas icon="trash"></mdb-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="editarUsuario.hide()"
            mdbWavesEffect>
            Cerrar
          </button>
          <button type="submit" class="btn btn-secondary waves-light" mdbWavesEffect [disabled]="
              formulario.invalid ||
              !usuarioSucursalList ||
              usuarioSucursalList.length === 0
            ">
            Guardar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
